import { operateMaxShowLength } from '@/store/dict/config'

export const mixin = {
  data() {
    return {
      orderInfo: {
        list: [
          {
            el: 'text',
            itemConfig: {
              label: '企业租赁主订单ID',
              prop: 'entRentOrderId',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '企业租赁主订单状态',
              prop: 'state',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '合同开始日期',
              prop: 'contractStartDate',
            },
          },
          {
            el: 'text',
            itemConfig: {
              label: '合同结束日期',
              prop: 'contractEndDate',
            },
          },
        ],
        model: {
          entRentOrderId: '',
          state: '',
          contractStartDate: '',
          contractEndDate: '',
          carTotalNum: 0,
        },
      },
      tableColumns: [
        {
          name: 'carId',
          columnProps: {
            prop: 'carId',
            label: '车辆ID',
          },
        },
        {
          name: 'plateNo',
          columnProps: {
            prop: 'plateNo',
            label: '车牌号',
            width: 100,
          },
        },
        {
          name: 'rentOrderId',
          columnProps: {
            prop: 'rentOrderId',
            label: '子订单ID',
          },
        },
        {
          name: 'rent',
          columnProps: {
            prop: 'rent',
            label: '每期租金',
            width: 110,
          },
        },
        {
          name: 'receivedDeposit',
          columnProps: {
            prop: 'receivedDeposit',
            label: '已交押金',
          },
        },
        {
          name: 'startDate',
          columnProps: {
            prop: 'startDate',
            label: '计租开始日',
          },
        },
        {
          name: 'endDate',
          columnProps: {
            prop: 'endDate',
            label: '计租结束日',
          },
        },
        {
          name: 'operate',
          columnProps: {
            label: '操作',
            fixed: 'right',
            width: 240,
          },
          maxShowLength: operateMaxShowLength,
          type: 'operate',
          getOperateList: ({ row }) => {
            return [
              {
                name: 'remove',
                label: '移除',
                action: () => {
                  this.$confirm('是否确认移除该条导入数据？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                  }).then(() => {
                    this.removeEnterpriseSubOrderRenewal(row.rentOrderId, this.previewId)
                  }).catch(() => null)
                },
              },
            ]
          },
        },
      ],
    }
  },
}
